<!--乐生活详情页-->
<template>
    <section id="hierarchDetails">
        <div class="main">
            <div class="article">
                <div class="p" v-html="magazineDetailDto.content"></div>
            </div>
            <!--投票组件-->
            <v-vote :magazineId="magazineId" :token="token" :params="params" :os="os" :isInAPP="isInAPP" :loaded="loaded"></v-vote>
            <!--精选投票组件-->
            <v-choiceness v-bind:magazineId="magazineId" :page="1" :size="3" :commentToken="commentToken" :loaded="loaded"></v-choiceness>
        </div>
        <!--评论部分-->
        <i></i>  <!--站位-->
        <div class="write">
            <img v-if="!imgUrl" src="../../assets/img/food_businessmen_logo@2x.png" alt="">
            <img v-else :src="imgUrl" alt="">
            <input type="text" placeholder="说出你的想法，遇见更多的知己" v-model="content">
            <button @click.prevent="myPostComment(token)" @input="godown">发送</button>
        </div>
    </section>
</template>

<script>
    import comVote from './vote.vue';
    import comChoiceness from './choiceness.vue';
    import {
      postComment,
      fetchVoteContent,
      fetchUserPhoto,
      fetchToken
    } from '../../common/api/homePage';
    import {
      Toast
    } from 'mint-ui';
    import {
      getDownURL
    } from "../../common/api.config";
    export default {
      data() {
        return {
          content: '',
          magazineId: '',
          flage: true,
          magazineDetailDto: '',
          fullPath: '',
          token: '',
          isInAPP: '',
          imgUrl: '',
          os: '',
          loaded: 0,
          commentToken: {},
          cmd: {
            "cmd": "", // 乐生活详情
            "url": "",
            "params": '',
            "h5Params": "{}",
            "events": []
          }
        }
      },
      beforeCreate() {
        fetchToken('cavfRKdfZRBAZMRUQzmdfqgsDsqREtsqeAbMPWnaJQFFPlhNEvHnatGpNOPQAnas').then(() => {
          this.loaded = 1
        });
      },
      computed: {
        params() {
          this.cmd.url = location.href.split('?')[0] + '?isInAPP=1'
          return this.cmd
        }
      },
      watch: {
        token(curVal) {
          let obj = {
            token: curVal
          };
          this.commentToken = obj;
          fetchUserPhoto(curVal).then((rep) => {
            if (rep.data.code === 0) {
              this.imgUrl = rep.data.data.avatarUrl;
            }
          })
        },
        loaded() {
          this.isOs();
          window.getAndrOpenToken = this.getAndrOpenToken;
          //            初始化获取文章内容
          this.getmagazineDetailDto();
          //            初始化获取token
          this.getToken();
        }
      },
      created() {
        this.fullPath = this.$route.fullPath.substring(0, this.$route.fullPath.lastIndexOf('/'));
        this.magazineId = this.$route.params.id;
        this.isInAPP = +this.$route.query.isInAPP;
      },
      mounted() {},
      methods: {
        getmagazineDetailDto() {
          fetchVoteContent(this.magazineId).then((rep) => {
            if (rep.data.code === 0) {
              this.magazineDetailDto = rep.data.data.magazineDetailDto;
              this.magazineDetailDto.content = rep.data.data.magazineDetailDto
                .content.replace(/[\d+.?]+px/g, word => {
                  return parseInt(word) / 10 + 'rem';
                });
              document.title = this.magazineDetailDto.title;
              this.cmd.h5Params = JSON.stringify({
                "isShare": true,
                "shareTitle": this.magazineDetailDto.title,
                "subTitle": this.magazineDetailDto.title,
                "shareIcon": ""
              })
            }
          });
        },
        getToken() {
          let _this = this
          if (this.isInAPP) {
            if (this.os === 'IOS') {
              fetchToken(prompt('GTWebCommonGetOpenToken')).then((rep) => {
                if (rep.data.code === 0) {
                  this.token = rep.data.data.accessToken;
                } else {
                  // 获取登录信息失败重新请求
                  if (_this.os === 'IOS') {
                    let opentoken = prompt('GTWebCommonGetOpenToken');
                    fetchToken(opentoken).then((rep) => {
                      if (rep.data.code === 0) {
                        this.token = rep.data.data.accessToken;
                      }
                    })
                  } else {
                    window.utopa.getOpenToken('getAndrOpenToken');
                  }
                }
              });
            } else {
              window.utopa.getOpenToken('getAndrOpenToken');
            }
          }
        },
        getAndrOpenToken(opentoken) {
          if (!opentoken) {
            // alert('获取openToken失败')
            return
          }
          let _this = this;
          fetchToken(opentoken).then((rep) => {
            if (rep.data.code === 0) {
              if (rep.data.data.accessToken) {
                _this.token = rep.data.data.accessToken;
              }
            }
          });
        },
        isOs() {
          let u = navigator.userAgent;
          let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        //   let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          this.os = isAndroid ? 'Android' : 'IOS';
        },
        godown() {
          document.getElementsByTagName('BODY')[0].scrollTop = document.getElementsByTagName('BODY')[0].scrollHeight;
        },
        myPostComment(token) {
          document.getElementsByTagName('BODY')[0].scrollTop = document.getElementsByTagName('BODY')[0].scrollHeight;
          if (!this.isInAPP) {
            // =============================================================================================================
            getDownURL(this.params);
            return
          }
          let _this = this;
          if (this.token && this.content) {
            if (_this.flage) {
              _this.flage = false;
              postComment(this.magazineId, this.content, token).then((rep) => {
                if (rep.data.code === 0) {
                  _this.content = '';
                  Toast({
                    message: rep.data.msg,
                    position: 'middle',
                    duration: 800
                  });
                  //                                改变commentToken指向，刷新精选评论列表
                  let obj = {
                    token: _this.token
                  };
                  _this.commentToken = obj;
                  _this.flage = true;
                } else {
                  if (rep.data.code === 99950006 || rep.data.code === 99950007 || rep.data.code === 99950005) {
                    if (_this.os === 'IOS') {
                      let opentoken = prompt('GTWebCommonGetOpenToken');
                      fetchToken(opentoken).then((rep) => {
                        if (rep.data.code === 0) {
                          this.token = rep.data.data.accessToken;
                        }
                      })
                    } else {
                      window.utopa.getOpenToken('getAndrOpenToken');
                    }
                  }
                }
              })
            }
          } else {
            if (this.content) {
              if (this.os === 'IOS') {
                let token = prompt('GTWebCommonGetOpenToken');
                fetchToken(token).then((rep) => {
                  if (rep.data.code === 0) {
                    this.token = rep.data.data.accessToken;
                    window.getVote(this.magazineId, this.token);
                  }
                })
              } else {
                window.utopa.getOpenToken("getAndrOpenToken");
              }
            }
          }

        }
      },
      components: {
        'v-vote': comVote,
        'v-choiceness': comChoiceness
      }
    }
</script>

<style lang="scss">
    @import '../../assets/css/px2rem.scss';
    #hierarchDetails{
        background-color: #fff;
        font-size: px2rem(14);
        line-height: px2rem(20);
        color:#666;
        .main{
            width: 100%;
            position: absolute;
            top:0;
            left: 0;
            bottom: px2rem(44);
            // 使之可以滚动
            overflow: scroll;
            overflow: auto;
            overflow-x: hidden;
            // 增加该属性，可以增加弹性
            -webkit-overflow-scrolling: touch;
            .article{
            padding:px2rem(12);
            p.title{
                text-align: right;
                color:#333;
                line-height: px2rem(44);
                overflow: hidden;
                a{
                    color:#999;
                }
            }
            div.p{
                width:100%;
                img{
                    max-width: 100%;
                    width: 100%;
                    height:100%;
                }
            }
            /*img{*/
            /*height:px2rem(200);*/
            /*width:100%;*/
            /*padding:px2rem(12) 0;*/
            /*}*/
            /*article{*/
            /*margin-bottom: px2rem(24);*/
            /*}*/
            /*h4{*/
            /*padding-left: px2rem(16);*/
            /*color:#333;*/
            /*font-size: px2rem(16);*/
            /*line-height: px2rem(22);*/
            /*position: relative;*/
            /*&::before{*/
            /*content: '';*/
            /*position: absolute;*/
            /*left: 0;*/
            /*top:px2rem(3);*/
            /*width:px2rem(4);*/
            /*height:px2rem(16);*/
            /*background-color: #FF4A2A;*/
            /*}*/
            /*}*/
        }
        i{
            height:px2rem(62);
            display: block;
            background-color: #f6f6f6;
        }
        }
        .write{
            position: absolute;
            display: flex;
            width:100%;
            max-width: 1280px;
            z-index: 10;
            left:0;
            bottom:0;
            height:px2rem(44);
            border-top: px2rem(1) solid #eee;
            background-color: #fff;
            *{
                float: left;
                margin: auto 0;
            }
            img{
                box-sizing: content-box;
                width:px2rem(28);
                height:px2rem(28);
                padding:px2rem(8) px2rem(12);
                border-radius: 50%;
            }
            input{
                width:px2rem(267);
                height:px2rem(28);
                border:none;
                background-color: #eee;
                border-radius: px2rem(80);
                padding-left: px2rem(20);
                font-size: px2rem(14);
            }
            button{
                padding:px2rem(11) px2rem(12);
                background-color: transparent;
                border:none;
                color: #ff4a2a;
                font-size: px2rem(16);
            }

        }
    }
    .mint-toast.is-placemiddle{
        padding:px2rem(10) !important;
        .mint-toast-text{
            font-size: px2rem(14);
        }
    }
</style>